// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-page__cta{display:flex;justify-content:flex-end;align-items:center;width:100%}", ""]);
// Exports
module.exports = exports;
